export const searchSharesByNameOrISIN = /* GraphQL */ `
  query SearchSharesByNameOrISIN(
    $searchKeyword: String
    $limit: Int
    $from: Int
  )
  {
    searchShares(
      filter: {
        or: [
          {name: {matchPhrasePrefix: $searchKeyword}},
          {isin: {matchPhrasePrefix: $searchKeyword}}
        ],
        and: [ $optionalAndFilters ]
      },
      sort: {field: name, direction: asc},
      limit: $limit
      from: $from
    )
    {
      items {
        $returnItem
      }
      nextToken
      total
    }
  }
`

export const searchEtfsByNameOrISIN = /* GraphQL */ `
  query SearchEtfsByNameOrISIN(
    $searchKeyword: String
    $limit: Int
    $from: Int
  )
  {
    searchEtfs(
      filter: {
        or: [
          {name: {matchPhrasePrefix: $searchKeyword}},
          {isin: {matchPhrasePrefix: $searchKeyword}}
        ],
        and: [ $optionalAndFilters ]
      },
      sort: {field: name, direction: asc},
      limit: $limit
      from: $from
    )
    {
      items {
        $returnItem
      }
      nextToken
      total
    }
  }
`

export const searchIndicesByNameOrISIN = /* GraphQL */ `
  query SearchIndicesByNameOrISIN(
    $searchKeyword: String
    $limit: Int
    $from: Int
  )
  {
    searchIndexs(
      filter: {
        or: [
          {name: {matchPhrasePrefix: $searchKeyword}},
          {isin: {matchPhrasePrefix: $searchKeyword}}
        ],
        and: [ $optionalAndFilters ]
      },
      sort: {field: name, direction: asc},
      limit: $limit
      from: $from
    )
    {
      items {
        $returnItem
      }
      nextToken
      total
    }
  }
`

export const searchAllByNameOrISIN = /* GraphQL */ `
  query SearchAllByNameOrISIN(
    $searchKeyword: String
    $limit: Int
    $from: Int
  )
  {
    searchInstruments(
      filter: {
        or: [
          {name: {matchPhrasePrefix: $searchKeyword}},
          {isin: {matchPhrasePrefix: $searchKeyword}}
        ],
        and: [ $optionalAndFilters ]
      },
      sort: {name: keyword_asc},
      limit: $limit
      from: $from
    )
    {
      items {
        instrument {
          ... on ShareInstrument {
            $returnItem
          }
          ... on EtfInstrument {
            $returnItem
          }
        }
      }
      total
    }
  }
`

export const DEFAULT_ITEM = 'id isin name'
export const DEFAULT_SHARE_ETF_ITEM = 'id isin name assetClass active covered delisted'
